import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared layout for legal pages (Impressum, Datenschutz).
 * Dark cinematic background, editorial typography, scrolls back to top on mount.
 */
export const LegalLayout = ({ title, eyebrow, children }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="relative min-h-screen" style={{ background: "var(--ink)" }}>
      {/* Ambient glow */}
      <div
        className="fixed inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 80% 0%, rgba(244,152,0,0.12), transparent 50%), radial-gradient(ellipse at 20% 100%, rgba(231,22,129,0.08), transparent 55%)",
        }}
        aria-hidden
      />

      <div className="relative z-10 max-w-[920px] mx-auto px-6 sm:px-10 py-20 lg:py-28">
        <Link
          to="/"
          className="inline-flex items-center gap-2 mb-12 font-mono text-[11px] uppercase tracking-[0.25em] text-mute hover:text-amber transition-colors"
          data-testid="legal-back"
        >
          <ArrowLeft size={14} /> Zurück zur Startseite
        </Link>

        <h1
          className="font-display font-bold leading-[1.05] tracking-[-0.03em] mb-12"
          style={{ fontSize: "clamp(40px, 5vw, 72px)" }}
        >
          {title}
        </h1>

        <div className="legal-content space-y-7 text-offwhite/85 text-[15px] leading-[1.75]">
          {children}
        </div>

        <div className="mt-20 pt-8" style={{ borderTop: "1px solid rgba(244,152,0,0.10)" }}>
          <Link
            to="/"
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-mute hover:text-amber transition-colors"
          >
            ← Zurück
          </Link>
        </div>
      </div>
    </div>
  );
};
